import React from 'react';
import PropTypes from 'prop-types';

const NonConnect = props => {
  const { color: _color, width: _width, height: _height, ...other } = props;

  return (
    <svg id="グループ_4177" data-name="グループ 4177" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" {...other}>
      <circle id="楕円形_35" data-name="楕円形 35" cx="16" cy="16" r="16" fill="#f2f7ff" />
      <g id="グループ_4188" data-name="グループ 4188" transform="translate(11 11)">
        <g id="グループ_4189" data-name="グループ 4189">
          <path id="パス_3703" data-name="パス 3703" d="M.354,2.736a7.633,7.633,0,0,1,10.794,0" transform="translate(-0.354 -0.5)" fill="none" stroke="#b3d0ff" strokeLinecap="round" strokeWidth="2" />
          <path id="パス_3704" data-name="パス 3704" d="M8.2,13.767a4.276,4.276,0,0,1,6.047,0" transform="translate(-5.822 -8.878)" fill="none" stroke="#b3d0ff" strokeLinecap="round" strokeWidth="2" />
          <g id="グループ_4190" data-name="グループ 4190" transform="translate(4.096 7.088)">
            <line id="線_34" data-name="線 34" x1="2.603" y1="2.603" transform="translate(0 0)" fill="none" stroke="#66a1ff" strokeLinecap="round" strokeWidth="2" />
            <line id="線_35" data-name="線 35" x1="2.603" y2="2.603" fill="none" stroke="#66a1ff" strokeLinecap="round" strokeWidth="2" />
          </g>
        </g>
      </g>
    </svg>
  );
}

NonConnect.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

NonConnect.defaultProps = {
  color: '#f2f7ff',
  width: 32,
  height: 32,
};

export default NonConnect;



// WEBPACK FOOTER //
// ./src/components/Icons/NonConnect.jsx